// extracted by mini-css-extract-plugin
export default {"List":"ListView_List__uIsJ-"};